import createTsdApi from "../../../client-api/createTsdApi";
import {
  SupplierInvoice,
  SupplierInvoiceCreateParams,
  SupplierInvoiceQueryParams,
  SupplierInvoiceUpdateParams,
} from "../../../entities/SupplierInvoice/supplierInvoice";
import { TsdSearchParam } from "../fetch";

const supplierInvoiceApi = createTsdApi<
  SupplierInvoice,
  SupplierInvoiceQueryParams,
  SupplierInvoiceCreateParams,
  SupplierInvoiceUpdateParams
>("supplier-invoices", (params) => {
  const search: TsdSearchParam<SupplierInvoiceQueryParams>[] = [];

  ({
    invoiceNumbers: (() => {
      if (typeof params.invoiceNumbers !== "undefined") {
        params.invoiceNumbers.forEach((invoiceNumber) =>
          search.push({ key: "invoiceNumbers", value: String(invoiceNumber) })
        );
      }
    })(),
    supplierIds: (() => {
      if (typeof params.supplierIds !== "undefined") {
        params.supplierIds.forEach((supplierId) =>
          search.push({ key: "supplierIds", value: String(supplierId) })
        );
      }
    })(),
    ids: (() => {
      if (typeof params.ids !== "undefined") {
        params.ids.forEach((id) =>
          search.push({ key: "ids", value: String(id) })
        );
      }
    })(),
    limit: (() => {
      if (typeof params.limit !== "undefined") {
        search.push({ key: "limit", value: String(params.limit) });
      }
    })(),
    offset: (() => {
      if (typeof params.offset !== "undefined") {
        search.push({ key: "offset", value: String(params.offset) });
      }
    })(),
  }) satisfies {
    [key in keyof Required<SupplierInvoiceQueryParams>]: void | undefined;
  };

  return search;
});

export default supplierInvoiceApi;
